import { Injectable } from '@angular/core';
import { FeatureService } from '@app/services/feature.service';
import { LDFlagSet } from 'launchdarkly-js-client-sdk';

@Injectable({ providedIn: 'root' })
export class FeatureFlagResolver {
    constructor(private service: FeatureService) {}

    async resolve(): Promise<LDFlagSet> {
        return await this.service.all();
    }
}
